import { WorkflowDestination } from ".";

// ボタン設定用model
export class ButtonInfo {
  // 権限有無フラグ
  public isPermitted: boolean;

  // WFトリガーコード
  public triggerCode: number;

  // ボタン名称
  public buttonName: string;

  // 行き先（差戻し先候補リストとして使用。それ以外のボタンでは null）
  public destinations: WorkflowDestination[];

  // 確認メッセージ
  public confirmMessage: string;

}
